import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

// Copies the public rich-preview share landing link (/g/:id) for a published game.
export function CopyShareLink({ gameId, className = "" }) {
  const copy = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const url = `${window.location.origin}/g/${gameId}`;
    navigator.clipboard.writeText(url).then(
      () => toast.success("Share link copied! 🔗", { description: url }),
      () => toast.error("Couldn't copy the link.")
    );
  };
  return (
    <button onClick={copy} title="Copy share link" data-testid={`share-link-${gameId}`}
      className={`w-8 h-8 rounded-full bg-black/55 text-white grid place-items-center backdrop-blur hover:bg-[hsl(var(--primary))] transition-colors ${className}`}>
      <Share2 className="w-3.5 h-3.5" />
    </button>
  );
}
